module.exports = __webpack_public_path__ + "static/media/purpleTheme-boy.347a9fb1.svg";